import React, { useCallback, useRef, useState } from "react";
import { IoCheckmark, IoCameraOutline } from "react-icons/io5";
import Webcam from "react-webcam";
import { live } from "../../../../assets/images";
import { FaRegTimesCircle } from "react-icons/fa";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import toast from "react-hot-toast";
import { API } from "../../../../constants/api";
import { errorMessage } from "../../../../utils/errorMessage";
import useAuthAxios from "../../../../utils/baseAxios";
import ClipLoader from "react-spinners/ClipLoader";

const LivenessCheck = ({
  livenessIdFile,
  setLivenessIdFile,
  setKycSuccess,
  setOpenKyc3Screens,
  livenessSignedUrl,
  setLivenessSignedUrl,
  setLivenessObjectUrl,
  livenessObjectUrl,
  utility,
  country,
  houseObjectUrl,
  houseNo,
  houseAddress,
  houseLandmark,
  document,
  govObjectUrl,

  govNumber,
  city,
  state,
  houseCountry,
  postalCode,
}: any) => {
  const webcamRef = useRef<Webcam | null>(null);
  const [showWebcam, setShowWebcam] = useState(false);
  const [photo, setPhoto] = useState<string | null>(null);
  const [uploaded, setUploaded] = useState<boolean>(false);
  const axiosInstance = useAuthAxios();

  const handleCapture = useCallback(() => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setPhoto(imageSrc);

      // Convert base64 image to file
      if (imageSrc) {
        const byteString = atob(imageSrc.split(",")[1]);
        const mimeString = imageSrc.split(",")[0].split(":")[1].split(";")[0];
        const arrayBuffer = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
          arrayBuffer[i] = byteString.charCodeAt(i);
        }
        const file = new File([arrayBuffer], "captured-photo.jpg", {
          type: mimeString,
        });
        setLivenessIdFile(file);
        if (livenessSignedUrl !== "") {
          completeIdUpload.mutate({
            file,
          });
        }
      }
      setShowWebcam(false);
    }
  }, [livenessSignedUrl, setLivenessIdFile]);
  //   console.log(govIdFile);
  const getUploadUrl = async (data: any) => {
    const response = await axiosInstance.post(API.getKyc3UploadURL, data);
    return response.data;
  };
  const completeGetUU = useMutation({
    mutationFn: getUploadUrl,
    onSuccess: (r) => {
      // toast.success(r.message);
      setLivenessObjectUrl(r.data.objectURL);
      setLivenessSignedUrl(r.data.signedURL);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      setLivenessObjectUrl("");
      setLivenessSignedUrl("");
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });
  const uploadImage = async ({ file }: any) => {
    const response = await axios.put(`${livenessSignedUrl}`, file, {
      headers: {
        "Content-Type": file.type, // Set content type to the MIME type of the file
      },
    });
    return response.data;
  };
  const completeIdUpload = useMutation({
    mutationFn: uploadImage,
    onSuccess: (r) => {
      // console.log(r);
      setUploaded(true);
      toast.success(`Selfie uploaded successfully`);
    },
    onError: (e) => {
      // console.log(e);
      setUploaded(false);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  const submitKyc3 = async (data: any) => {
    const response = await axiosInstance.post(API.submitKyc3, data);
    return response.data;
  };
  const completeKyc3 = useMutation({
    mutationFn: submitKyc3,
    onSuccess: (r) => {
      toast.success(r.message);
      setTimeout(() => {
        setOpenKyc3Screens(false);
        setKycSuccess(true);
      }, 1500);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  const handleSubmit = () => {
    const data = {
      documentOrigin: country,

      governmentID: {
        category: document,
        imageURL: govObjectUrl,
        number: govNumber,
      },
      proofOfAddress: {
        houseAddress: {
          apartmentNumber: houseNo,
          streetName: houseAddress,
          landmark: houseLandmark,
          city: city,
          state: state,
          // country: country,
          postalCode: postalCode,
        },
        utilityBill: {
          category: utility,
          imageURL: houseObjectUrl,
        },
      },
      livelinessCheck: {
        imageURL: livenessObjectUrl,
      },
    };
    completeKyc3.mutate(data);
  };

  return (
    <div className="w-full font-manrope">
      <div className="flex w-full gap-2 justify-start items-center">
        <div className="w-[24px] h-[24px] rounded-full bg-[#0B6F18] font-sora text-white text-[10px] flex justify-center items-center">
          <IoCheckmark />
        </div>
        <div className="w-[24px] h-[24px] rounded-full bg-[#0B6F18] font-sora text-white text-[10px] flex justify-center items-center">
          <IoCheckmark />
        </div>

        <div className="w-[24px] h-[24px] rounded-full border-[0.5px] border-[#0B75C2] bg-[#E9F1FF] font-sora text-secondary_button flex justify-center items-center">
          3
        </div>
        <h4 className="text-[12px] text-black dark:text-white font-sora font-bold">
          Liveness Check
        </h4>
      </div>

      <div className="w-full mt-10">
        <h4 className="text-black dark:text-white text-center font-semibold font-sora text-[16px]">
          Liveness Check
        </h4>

        <div className="mt-10 border-dashed border-gray-200 border rounded-xl p-4">
          <div className="mt-12 flex flex-col justify-center items-center">
            {showWebcam ? (
              <>
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{
                    facingMode: { ideal: "user" },
                  }}
                  className="w-full max-w-sm rounded-md"
                />
                <button
                  onClick={handleCapture}
                  className="w-full mt-4 rounded-lg h-[40px] bg-secondary_button flex justify-center items-center gap-2 text-white"
                >
                  Capture Photo
                </button>
              </>
            ) : livenessIdFile ? (
              <div>
                <img
                  src={URL.createObjectURL(livenessIdFile)}
                  alt="Captured"
                  className="w-60 h-60 object-cover rounded-md"
                />
                <button
                  onClick={() => {
                    setPhoto(null);
                    setUploaded(false);
                    setLivenessIdFile(null);
                  }}
                  className="mt-4 w-full h-[40px] flex gap-2 justify-center items-center mx-auto bg-transparent border border-[#D92B2B] rounded-xl text-[#D92B2B] font-medium text-[15px] "
                >
                  <FaRegTimesCircle className="" />
                  Retake Image
                </button>
              </div>
            ) : (
              <>
                <div className="mx-auto">
                  <img src={live} className="" alt="" />
                </div>
                <button
                  onClick={() => {
                    const data = {
                      documentType: "livelinessCheck",
                    };
                    completeGetUU.mutate(data);
                    setShowWebcam(!showWebcam);
                  }}
                  className="w-1/2 mt-4 rounded-lg h-[40px] bg-secondary_button flex justify-center items-center gap-2 text-white"
                >
                  <IoCameraOutline />
                  <h4 className="text-[11px]">
                    {showWebcam ? "Close Camera" : "Take a Photo"}
                  </h4>
                </button>
              </>
            )}
          </div>
        </div>
        <h4 className="text-gray-400 mt-4 text-center text-[12px]">
          File size must be between 100kb and 8mb
        </h4>
        <h4 className="text-gray-400 mt-2 text-center text-[12px]">
          jpg / jpeg / png format
        </h4>
        <button
          disabled={
            (!photo && !livenessIdFile) || !uploaded || completeKyc3.isPending
          }
          onClick={handleSubmit}
          className={
            (!photo && !livenessIdFile) || !uploaded || completeKyc3.isPending
              ? "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-gray-200 rounded-xl bg-gray-400"
              : "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-white rounded-xl bg-secondary_button"
          }
        >
          {completeIdUpload.isPending ? (
            <div className="bg-transparent flex justify-center gap-2 items-center">
              Uploading
              <ClipLoader color="#ffffff" size={20} />
            </div>
          ) : (
            <>
              {completeKyc3.isPending ? (
                <ClipLoader color="#ffffff" size={20} />
              ) : (
                "Next"
              )}
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default LivenessCheck;
